import React from 'react';
import {Link} from 'react-router-dom';

const NavBar = () => {
  return (
    <React.Fragment>
      <header id='header' className='alt'>
        <Link to='/' className='logo'>
          <strong>Esthra</strong> <span>Shakara</span>
        </Link>
        <nav>
          <a href='#menu'>Menu</a>
        </nav>
      </header>

      <nav id='menu'>
        <ul className='links'>
          <li>
            <Link to='/'>Home</Link>
          </li>
          <li>
            <Link to='/gallery'>Gallery</Link>
          </li>
        </ul>
        <ul className='actions stacked'>
          <li>
            <Link to='/about' className='button primary fit'>
              About Me
            </Link>
          </li>
          <li>
            <a
              href='https://esthrashakara-portal.web.app/'
              target='_blank'
              rel='noopener noreferrer'
              className='button fit'
            >
              Log In
            </a>
          </li>
        </ul>
      </nav>
    </React.Fragment>
  );
};

export default NavBar;
